import AuthenticationSection from 'components/enter/AuthenticationSection';
import HowToPlayPopup from 'components/enter/HowToPlayPopup';
import { PageState } from 'components/enter/PageContent';
import PaymentAndUpsellSection from 'components/enter/PaymentAndUpsellSection';
import PlayPageTitle from 'components/enter/PlayPageTitle';
import PrizesTableAndPlantTreeSection from 'components/enter/PrizesTableAndPlantTreeSection';
import ConfigureTicketAndSubscription from 'components/enter/with-one-time-purchases/ConfigureTicketAndSubscription';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { ValueOf } from 'next/dist/shared/lib/constants';
import { useEffect, useState } from 'react';
import { scrollToSection } from 'utils/common';
import { colors } from 'utils/constants';
import OrderSummary from '../order-summary/OrderSummary';
import WhenYouWinChooseFrom from '../WhenYouWinChooseFrom';

const PreselectedEMDesign3 = observer(() => {
  const { entryMethod } = useEnterStore();
  const [showHowToPlayPopup, setShowHowToPlayPopup] = useState(false);
  const [editingEntries, setEditingEntries] = useState(false);
  const [pageState, setPageState] = useState<ValueOf<typeof PageState>>(
    PageState.ENTRY_METHOD_SELECTION
  );

  useEffect(() => {
    if (editingEntries) {
      scrollToSection('#enterNow');
      setEditingEntries(false);
    }
  }, []);

  return (
    <div className="preselectedEMDesign2 fullWidth flexCentered">
      {pageState < PageState.AUTHENTICATION ? (
        <>
          <div
            className="fullWidth flexCentered"
            style={{ paddingBottom: '2em' }}
          >
            {showHowToPlayPopup ? (
              <HowToPlayPopup
                entryMethod={entryMethod}
                setShowHowToPlayPopup={setShowHowToPlayPopup}
              />
            ) : null}

            <PlayPageTitle preselectedEntryMethod={entryMethod} />
            <PaddedMaxWidthContainer
              additionalClassName="mainContainer"
              id={undefined}
            >
              <WhenYouWinChooseFrom
                additionalClassName="desktop-only"
                entryMethod={entryMethod}
              />

              <div className="configureTicketAndSubscriptionBox grid gap-2em fullWidth">
                <ConfigureTicketAndSubscription
                  id="enterNow"
                  setPageState={setPageState}
                />
              </div>
            </PaddedMaxWidthContainer>
          </div>
          <PrizesTableAndPlantTreeSection entryMethod={entryMethod} />
        </>
      ) : (
        <div
          className={
            pageState === PageState.AUTHENTICATION
              ? ''
              : 'flowWithOrderSummaryWrapper'
          }
        >
          {' '}
          {/* 2-column layout with order summary on right (desktop) or top (mobile) */}
          <div className={`orderSummary px-4 !mt-4`}>
            <OrderSummary />
          </div>
          <div className="flowContent">
            {/* Authentication */}
            {pageState === PageState.AUTHENTICATION && (
              <AuthenticationSection setPageState={setPageState} />
            )}

            {/* Payment */}
            {pageState >= PageState.ADD_ON_AND_PROMO && (
              <PaymentAndUpsellSection pageState={pageState} />
            )}
          </div>
        </div>
      )}

      <style jsx>
        {`
          .configureTicketAndSubscriptionBox {
            padding: 2em 0 0;
          }

          .flowWithOrderSummaryWrapper {
            width: 100%;
            max-width: 1200px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-areas:
              'order-summary order-summary'
              'flow-content flow-content';
          }

          .flowContent {
            width: 100%;
            grid-area: flow-content;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .orderSummary {
            width: 100%;
            grid-area: order-summary;
            display: flex;
            align-items: start;
          }

          @media (min-width: 700px) {
            .configureTicketAndSubscriptionBox {
              background: white;
              box-shadow: 0 2px 3px ${colors.primaryBrandGray}50;
              border-radius: 10px;
              padding: 5em 5%;
              align-self: stretch;
              position: relative;
              width: 100%;
            }
          }

          @media (min-width: 1000px) {
            :global(.pageContent .mainContainer) {
              flex-direction: row;
              justify-content: space-between;
              margin-top: -200px;
              align-items: flex-start;
            }

            :global(.pageContent .whenYouWinChooseFrom) {
              padding-top: 270px !important;
              padding-bottom: 0;
              width: fit-content;
              margin-right: 9%;
            }

            :global(.pageContent p) {
              font-size: 1.2em;
            }

            .flowWithOrderSummaryWrapper {
              grid-template-areas:
                'flow-content order-summary'
                'flow-content order-summary';
            }
          }
        `}
      </style>
    </div>
  );
});

export default PreselectedEMDesign3;
